"use strict";

exports.__esModule = true;
exports.CalendarSettingsScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _TimezoneForm = require("../Timezone/TimezoneForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CalendarSettingsScreen = exports.CalendarSettingsScreen = function CalendarSettingsScreen() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("CalendarSettingsScreen.title", "Calendar Settings"),
    "data-testid": "CalendarSettingsScreen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("CalendarSettingsScreen.navbar.title", "Calendar Settings")
  }), /*#__PURE__*/_react["default"].createElement(_TimezoneForm.TimezoneForm, null));
};